import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const DEFAULT_PARAM = "tab";

const Tabs = ({
  tabs = [],
  paramName = DEFAULT_PARAM,
  currentTab,
  setCurrentTab,
  noParams = false,
  pillStyled = false,
}) => {
  const location = useLocation();

  const changeTab = (tab) => {
    setCurrentTab(tab);
    if (noParams) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(paramName, tab.path);
    window.history.pushState({}, "", "?" + searchParams.toString());
  };

  useEffect(() => {
    if (tabs.length > 0 && !noParams) {
      const searchParams = new URLSearchParams(location.search);
      const tabParam = searchParams.get(paramName);
      const tab = tabs.find((tab) => tab.path === tabParam);

      if (searchParams.has(paramName) && tab) {
        setCurrentTab(tab);
      } else changeTab(tabs[0]);
    } else if (tabs.length > 0 && noParams && !currentTab) {
      setCurrentTab(tabs[0]);
    }
  }, []);

  return (
    <TabsContainer pillStyled={pillStyled}>
      {tabs.map((tab) => {
        const isActiveTab =
          tab?.path?.toLocaleLowerCase() ===
          currentTab?.path?.toLocaleLowerCase();

        return (
          <Tab
            pillStyled={pillStyled}
            isActiveTab={isActiveTab}
            onClick={() => changeTab(tab)}
            key={tab?.path}
          >
            {tab.title}
          </Tab>
        );
      })}
    </TabsContainer>
  );
};

export default Tabs;

export const Tab = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px !important;

  ${({ isActiveTab, pillStyled }) => {
    if (pillStyled) {
      if (isActiveTab) {
        return `
             background-color: black;
            border: 1px solid black;
             border-radius: 20px;
              color: white;
           `;
      } else {
        return `
             background-color: white;
             border: 1px solid black;
             border-radius: 20px;
              color: black;

            `;
      }
    } else {
      if (isActiveTab) {
        return `
          color: black;
          border-bottom: 2px solid black;
        `;
      } else {
        return `
          color: gray;
          border-bottom: 2px solid transparent;

          &:hover {
            color: black;
          }
        `;
      }
    }
  }};

  transition: border 0.2s, border-bottom 0.3s;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: ${({ pillStyled }) => (pillStyled ? "12px" : "20px")};
  border-bottom: 1px solid
    ${({ pillStyled }) => (pillStyled ? "none" : "#dddddd")};
  width: 100%;
`;
